<h1 class="global-red" mat-dialog-title>You are not able to make edits to the Bank of America Background Check Form</h1>

<div mat-dialog-content aria-live="polite">

    <p>Are you sure you would like to submit the Bank of America Background
        Check Form and that all information provided is accurate to the best of your knowledge?</p>
    <p>
        <strong>Note:</strong> Once you submit this form, you will not be
        able to make any edits and will be locked out of the form. Click the Cancel button if you'd like to review your
        information again prior to submitting.
    </p>

</div>

<div mat-dialog-actions>
    <div class="is-taller">
        <div class="level">
            <div class="level-item">
                <button class="bofa--button secondary outlined" type="button" (click)="onNoClick()">Cancel</button>
                <button class="bofa--button secondary" type="button" (click)="onOkClick()">Ok</button>
            </div>
        </div>
    </div>
</div>